import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth";
import timer from "./modules/timer";
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
    }),
  ],
  state() {
    return {};
  },
  mutations: {
  },
  actions: {
  },
  getters: {
  },
  modules: {
    auth,
    timer
  },
});
